if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      let isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;

      if(isMobile){
        this.initSlider(swiperOptions);

        window.addEventListener('shopify:section:load', e => {
          this.initSlider(swiperOptions);
        });
      }else{
        this.parentNode.classList.add('announcement-without-slider');
      }
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: 1,
        loop: swiperOptions.loop || false,
        allowTouchMove: false,
        autoplay: swiperOptions.autoplay || false,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev")
        }
      });
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
